export enum ProductCardMode {
  productList,
  wishlist,
  recommended,
  gifts
}
